import React, { useState, useEffect, useMemo } from "react";
import Card from "../../components/Card";
import { useNavigate } from "react-router-dom";
import { Row, Col, OverlayTrigger, Tooltip, Button } from 'react-bootstrap'
import { FaEdit } from "react-icons/fa";
import ReportService from "../../services/report/ReportService";
import DataTable from "react-data-table-component";
import { set } from "date-fns";

//progressbar
// import Progress from "../../../components/progress.js";

const Report1 = () => {
  let RepService = useMemo(() => new ReportService(), []);
  const [reports, setReports] = useState([]);
  const [filterRecord, setFilterRecord] = useState([])

  const navigate = useNavigate();

  const EditTRader = (kdTrader) => {
    localStorage.removeItem('editTraderStorage')
    localStorage.setItem('editTraderStorage', kdTrader)
    navigate('/setting/edit-trader')
  }

  const columns = [
    {
      name: "NOMOR AJU",
      selector: row => row.NOMOR_AJU,
    },
    {
      name: "TANGGAL AJU",
      selector: row => row.TANGGAL_AJU,
    },
    {
      name: "UPT",
      selector: row => row.tb_r_upt.UPT,
    },
    {
      name: "NAMA TRADER",
      selector: row => row.NAMA_TRADER,
    },
    {
      name: "PELABUHAN MUAT",
      selector: row => row.pelabuhan_muat.PELABUHAN_MUAT,
    },
    {
      name: "PELABUHAN MUAT",
      selector: row => row.pelabuhan_bongkar.PELABUHAN_BONGKAR,
    },
    {
      name: "NEGARA TUJUAN",
      selector: row => row.tb_r_negara.NEGARA_TUJUAN,
    },
    // {
    //   name: "NPWP",
    //   selector: row => row.NPWP,
    // },
    // {
    //   name: "EMAIL",
    //   selector: row => row.EMAIL,
    // },
    // {
    //   name: "TELEPON",
    //   selector: row => row.TELEPON,
    // },
    // {
    //   name: "NAM USER",
    //   selector: row => row.tb_users[0].NAMA,
    // },
    {
      name: "ACTION",
      cell: row => <div className="flex align-items-center list-user-action">
        <div className="col-sm-4">
          <OverlayTrigger placement="bottom" overlay={
            <Tooltip >View Ekspor</Tooltip>
          }>
            {/* <Button size="sm" variant="warning" onClick={() => EditTRader(row.KODE_TRADER)}> */}
            <Button size="sm" variant="warning">
              <FaEdit />
            </Button>
          </OverlayTrigger>
        </div>
      </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];

  useEffect(() => {
    getReports();
  }, []);

  useEffect(() => {
    let roleUser = localStorage.getItem('role')
    if (roleUser !== "1" && roleUser !== "2") {
      navigate('/dashboard')
    }
  }, [navigate]);

  const getReports = async () => {
    const response = await RepService.getAll()
    setReports(response.data)
    setFilterRecord(response.data)
  };

  const handleFilter = (event) => {
    console.log(event.target.value)
    const newData = filterRecord.filter(row => row["NOMOR_AJU"].toLowerCase().includes(event.target.value.toLowerCase()))
    setReports(newData)
  }

  const ExpandedComponent = ({ data }) => (
    <div style={{ padding: '10px', fontStyle: 'italic' }}>
       <h4>Detail Detail:</h4>
    <ul>
      {Object.entries(data.tr_ppk_dtls).map(([key]) => (
        <li key={key}>
          <strong>{key.toUpperCase()}:</strong> {data.tr_ppk_dtls[key]}
        </li>
      ))}
    </ul>
    </div>
  );

  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header d-flex justify-content-between>
              <Row>
                <Col sm="6">
                  <div className="header-title">
                    <h4 className="card-title">Rekapitulasi</h4>
                  </div>
                </Col>
                <Col sm="6">
                  <div className="input-group search-input">
                    <span className="input-group-text" id="search-input">
                      <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                        <path d="M18.0186 18.4851L21.5426 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                    </span>
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Search..."
                      onChange={handleFilter}
                    />
                  </div>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <DataTable
                columns={columns}
                data={reports}
                pagination
                expandableRows
                expandOnRowDoubleClicked
                expandableRowsComponent={ExpandedComponent}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Report1;
